const playlists = {};
const prefetchedTracks = new Map();
const MAX_PREFETCH_KEEP = 10;
const MAX_PLAYLIST_LENGTH = 1000;
const PLAYLIST_MIME_TYPES = [
  "audio/x-mpegurl",
  "audio/mpegurl",
  "application/vnd.apple.mpegurl",
  "application/mpegurl",
  "application/x-mpegurl",
  "application/octet-stream",
];
function stripUrlParameters(link) {
  const url = new URL(link, window.location);
  url.search = "";
  url.hash = "";
  return url.href;
}
function isPlaylist(link) {
  const linkHref = stripUrlParameters(link);
  return linkHref.endsWith(".m3u") || linkHref.endsWith(".m3u8");
}
function isBlob(link) {
  return new URL(link, window.location).protocol == "blob";
}
function parsePlaylist(textContent) {
  return textContent.match(/^(?!#)(?!\s).*$/gm).filter((s) => s);
}
function fetchPlaylist(url, onload, onerror) {
  const playlistFetcher = new XMLHttpRequest();
  playlistFetcher.open("GET", url, true);
  playlistFetcher.responseType = "blob";
  playlistFetcher.onload = () => {
    if (PLAYLIST_MIME_TYPES.includes(playlistFetcher.response.type)) {
      const reader = new FileReader();
      const load = onload;
      reader.addEventListener("loadend", (e) => {
        playlists[url] = parsePlaylist(reader.result);
        onload();
      });
      reader.readAsText(playlistFetcher.response);
    } else {
      console.error(
        "playlist must have one of the playlist MIME type '" +
          PLAYLIST_MIME_TYPES +
          "' but it had MIME type '" +
          playlistFetcher.response.type +
          "'."
      );
      onerror();
    }
  };
  playlistFetcher.onerror = onerror;
  playlistFetcher.abort = onerror;
  playlistFetcher.send();
}
function servedPartialDataAndCanRequestAll(xhr) {
  if (xhr.status === 206) {
    if (xhr.getResponseHeader("content-range").includes("/")) {
      if (!xhr.getResponseHeader("content-range").includes("/*")) {
        return true;
      }
    }
  }
  return false;
}
function prefetchTrack(url, onload) {
  if (prefetchedTracks.has(url)) {
    return;
  }
  while (prefetchedTracks.size > MAX_PREFETCH_KEEP) {
    const key = prefetchedTracks.keys().next().value;
    const track = prefetchedTracks.get(key);
    prefetchedTracks.delete(key);
  }
  prefetchedTracks.set(url, url);
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = () => {
    if (servedPartialDataAndCanRequestAll(xhr)) {
      const endRange =
        Number(xhr.getResponseHeader("content-range").split("/")[1]) - 1;
      const rangeXhr = new XMLHttpRequest();
      rangeXhr.open("GET", url, true);
      rangeXhr.responseType = "blob";
      rangeXhr.setRequestHeader("range", "bytes=0-" + endRange);
      rangeXhr.onload = () => {
        prefetchedTracks.set(url, rangeXhr.response);
        if (onload) {
          onload();
        }
      };
      rangeXhr.send();
    } else {
      prefetchedTracks.set(url, xhr.response);
      if (onload) {
        onload();
      }
    }
  };
  xhr.send();
}
function showStaticOverlay(mediaTag, canvas) {
  if (mediaTag instanceof Audio) {
    return;
  }
  const realWidth = mediaTag.getBoundingClientRect().width;
  const realHeight = mediaTag.getBoundingClientRect().height;
  canvas.width = realWidth;
  canvas.height = realHeight;
  const videoAspectRatio = mediaTag.videoHeight / mediaTag.videoWidth;
  const tagAspectRatio = realHeight / realWidth;
  const videoIsPartialHeight = tagAspectRatio > videoAspectRatio * 1.01;
  const videoIsPartialWidth = videoAspectRatio > tagAspectRatio * 1.01;
  if (videoIsPartialHeight) {
    canvas.height = realWidth * videoAspectRatio;
  } else if (videoIsPartialWidth) {
    canvas.width = realHeight / videoAspectRatio;
  }
  const context = canvas.getContext("2d");
  context.scale(
    canvas.width / mediaTag.videoWidth,
    canvas.height / mediaTag.videoHeight
  );
  context.drawImage(mediaTag, 0, 0);
  canvas.hidden = true;
  mediaTag.parentNode.insertBefore(canvas, mediaTag.nextSibling);
  canvas.style.position = "absolute";
  if (videoIsPartialWidth) {
    canvas.style.marginLeft = "-" + (realWidth + canvas.width) / 2 + "px";
  } else {
    canvas.style.marginLeft = "-" + realWidth + "px";
  }
  if (videoIsPartialHeight) {
    canvas.style.marginTop = (realHeight - canvas.height) / 2 + "px";
  }
  canvas.hidden = false;
}
function updateSrc(mediaTag, callback) {
  const playlistUrl = mediaTag.getAttribute("playlist");
  const trackIndex = mediaTag.getAttribute("track-index");
  let playlist = [...playlists[playlistUrl]];
  let trackUrl = playlist[trackIndex];
  if (isPlaylist(trackUrl)) {
    if (playlist.length >= MAX_PLAYLIST_LENGTH) {
      changeTrack(mediaTag, +1);
    } else {
      fetchPlaylist(
        trackUrl,
        () => {
          playlist.splice(trackIndex, 1, ...playlists[trackUrl]);
          playlists[playlistUrl] = playlist;
          updateSrc(mediaTag, callback);
        },
        () => callback()
      );
    }
  } else {
    let url = prefetchedTracks.has(trackUrl)
      ? prefetchedTracks.get(trackUrl) instanceof Blob
        ? URL.createObjectURL(prefetchedTracks.get(trackUrl))
        : trackUrl
      : trackUrl;
    const oldUrl = mediaTag.getAttribute("src");
    const canvas = document.createElement("canvas");
    if (!isNaN(mediaTag.duration) && document.fullscreen !== true) {
      try {
        showStaticOverlay(mediaTag, canvas);
      } catch (error) {
        console.log(error);
      }
    }
    mediaTag.style.height =
      mediaTag.getBoundingClientRect().height.toString() + "px";
    mediaTag.style.width =
      mediaTag.getBoundingClientRect().width.toString() + "px";
    mediaTag.setAttribute("src", url);
    mediaTag.oncanplaythrough = () => {
      if (!isNaN(mediaTag.duration)) {
        mediaTag.style.height = null;
        mediaTag.style.width = null;
      }
      canvas.hidden = true;
      canvas.remove();
    };
    setTimeout(() => canvas.remove(), 300);
    if (url == trackUrl) {
      prefetchTrack(trackUrl, () => {
        if (mediaTag.paused) {
          if (url == mediaTag.getAttribute("src")) {
            if (mediaTag.currentTime === 0) {
              mediaTag.setAttribute(
                "src",
                URL.createObjectURL(prefetchedTracks.get(url))
              );
            }
          }
        }
      });
    }
    if (isBlob(oldUrl)) {
      URL.revokeObjectURL(oldUrl);
    }
    for (const i of [1, 2, 3]) {
      if (playlist.length > Number(trackIndex) + i) {
        prefetchTrack(playlist[Number(trackIndex) + i]);
      }
    }
    callback();
  }
}
function changeTrack(mediaTag, diff) {
  const currentTrackIndex = Number(mediaTag.getAttribute("track-index"));
  const nextTrackIndex = currentTrackIndex + diff;
  const tracks = playlists[mediaTag.getAttribute("playlist")];
  if (nextTrackIndex >= 0) {
    if (tracks.length > nextTrackIndex) {
      mediaTag.setAttribute("track-index", nextTrackIndex);
      updateSrc(mediaTag, () => mediaTag.play());
    }
  }
}
function initPlayer(mediaTag) {
  mediaTag.setAttribute("playlist", mediaTag.getAttribute("src"));
  mediaTag.setAttribute("track-index", 0);
  const url = mediaTag.getAttribute("playlist");
  const wrapper = mediaTag.parentElement.insertBefore(
    document.createElement("div"),
    mediaTag
  );

  wrapper.appendChild(mediaTag);
  fetchPlaylist(
    url,
    () => {
      updateSrc(mediaTag, () => null);
      mediaTag.addEventListener("ended", (event) => {
        if (mediaTag.currentTime <= mediaTag.duration) {
          changeTrack(mediaTag, +1);
        }
      });
    },
    () => null
  );
  const controls = document.createElement("div");

  mediaTag.resizeObserver = new ResizeObserver((entries) => {
    controls.style.width = entries[0].contentRect.width.toString() + "px";
  });
  mediaTag.resizeObserver.observe(mediaTag);
}
export const processTag = (mediaTag) => {
  const canPlayClaim = mediaTag.canPlayType("audio/x-mpegurl");
  let supportsPlaylists = !!canPlayClaim;
  if (canPlayClaim == "maybe") {
    supportsPlaylists = false;
  }
  if (!supportsPlaylists) {
    if (isPlaylist(mediaTag.getAttribute("src"))) {
      initPlayer(mediaTag);
    }
  }
};
